// extracted by mini-css-extract-plugin
export default {"columns":"AuthenticatedDiaglog-columns_ST53D"};